import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";

import { WithCaptcha } from '../../containers/captcha';
import logo from './img/cirtel-logo.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)} className="login">
          <div className="wrapper-cirtel fadeInDown">
            <div id="snackbar"></div>
            <div id="formContent-cirtel">
              <div className="menu1-cirtel">
                <div className="fadeIn first">
                </div>
                <div className="cirtel-logo">
                  <img src={logo} alt="cirtel" />
                </div>
                <div><p className="detail-cirtel">{translate("UserName")}</p></div>
                <input
                  className="fadeIn second"
                  disabled={onLogin}
                  onChange={e => setUsername(e.target.value)}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="login"
                  id="login-cirtel"
                  placeholder={translate("PlaceholderUserName")}
                />
                <div><p className="detail-cirtel">{translate("Password")}</p></div>
                <input
                  className="fadeIn third"
                  required={true}
                  disabled={onLogin}
                  onChange={e => setPassword(e.target.value)}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password-cirtel"
                  name="login"
                  placeholder={translate("PlaceholderPassword")}
                >
                </input>
                {/* TODO: activar cuando el cliente confirme cuál es la url para el cambio de contraseña
                      <p className='forgotPass-cirtel'><a href="https://silicomlan.ispcube.online/dgo/recoverpassword?company=573#/" target="_blank" rel="noopener noreferrer">{translate('ForgotPassword')}</a></p> */}
                <div className="buttons-cirtel">
                  {!onLogin ? (
                    <button type="submit" className="fadeIn fourth" id="entrar-cirtel" disabled={!props.turnstileSuccess} >
                      <span className="entrar-text" id="text">
                        {translate("ButtonEnter")}
                      </span>
                    </button>
                  ) : (
                    <Progress animated color="danger" value={100} />
                  )}
                </div>
                <div className="messages-container">
                  <Alert
                    color="danger"
                    id="error-message"
                    isOpen={error.open}
                    toggle={() => setError({ open: false })}
                  >
                    {error.message}
                  </Alert>
                </div>
              </div>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            </div>
          </div>
        </Form>
      </div>

    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
